import React, { useContext } from 'react';
import { formTimeString, areProgramMetadataValid } from '@24i/player-utils';
import { PlayerUIContext } from '@24i/player-ui';
import { usePlayerTimes } from '@24i/player-utils-react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Time } from '../PlayerUI/RegularView/components/PlayerFooter/styled';
const HOUR_MS = 60 * 60 * 1000;
export const ElapsedTime = ({ playerInstance, programRange, showHours, className, style, }) => {
    var _a, _b;
    const isLive = !!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live);
    const { elapsedTime } = usePlayerTimes(playerInstance);
    let milliseconds = elapsedTime;
    if (isLive && playerInstance) {
        const { programStart, programEnd } = playerInstance.getMetadata();
        const rangeStart = (_a = programRange === null || programRange === void 0 ? void 0 : programRange.start) !== null && _a !== void 0 ? _a : programStart;
        const rangeEnd = (_b = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _b !== void 0 ? _b : programEnd;
        const timestamp = playerInstance.getUTCTimestamp(milliseconds);
        if (areProgramMetadataValid(rangeStart, rangeEnd)) {
            milliseconds = rangeStart;
        }
        else if (timestamp) {
            milliseconds = timestamp.getTime();
        }
        else if (playerInstance.timeshiftRange) {
            milliseconds = Date.now() - (playerInstance.timeshiftRange.end - elapsedTime);
        }
    }
    const { state: { isVolumeOpened }, } = useContext(PlayerUIContext);
    const { theme } = useTheme();
    const finalShowHours = showHours === true || (showHours === 'auto' && (isLive || milliseconds > HOUR_MS));
    return (React.createElement(Time, { "data-test": "ElapsedTime-Time", testID: "elapsed_time", className: `ElapsedTime-Time ${className}`, style: Object.assign(Object.assign({}, getFont(theme, 'h5')), style), theme: theme, isVolumeOpened }, formTimeString(milliseconds, finalShowHours, isLive)));
};
ElapsedTime.defaultProps = {
    showHours: true,
    className: '',
    style: null,
};
//# sourceMappingURL=index.js.map